import React from 'react';
import EmptyState from './EmptyState';
import { classNames } from '../../utils/format';

export default function DataTable({
  columns,
  rows,
  rowKey = 'id',
  empty,
  className,
}) {
  if (!rows || rows.length === 0) {
    return (
      <div className="table-empty">
        {empty || <EmptyState />}
      </div>
    );
  }

  return (
    <div className="table-wrap">
      <table className={classNames(className)}>
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key} style={col.headerStyle} className={col.headerClassName}>{col.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, idx) => {
            const k = typeof rowKey === 'function' ? rowKey(row, idx) : row[rowKey] ?? idx;
            return (
              <tr key={k}>
                {columns.map((col) => (
                  <td key={col.key} className={col.cellClassName}>
                    {col.render ? col.render(row, idx) : row[col.key]}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
